import { createContext, type Dispatch, type SetStateAction } from 'react';

import { type LeagueMyRewardType } from '@/common/types/league';

interface LeagueClaimRewardContextType {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  setMyRewards: Dispatch<SetStateAction<LeagueMyRewardType[]>>;
  setLeagueId: Dispatch<SetStateAction<string | undefined>>;
  setLeagueShortInfo: Dispatch<
    SetStateAction<{ name: string; num: number } | null>
  >;
}

const LeagueClaimRewardContext = createContext(
  {} as LeagueClaimRewardContextType,
);

export { LeagueClaimRewardContext };
